import React, { useState } from "react";
import { toast } from "react-toastify";

import { makeStyles } from "@material-ui/core/styles";
import { green } from "@material-ui/core/colors";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContentText from "@material-ui/core/DialogContentText";
import CircularProgress from "@material-ui/core/CircularProgress";
import Typography from "@material-ui/core/Typography";
import WarningIcon from "@material-ui/icons/Warning";

import { i18n } from "../../translate/i18n";
import toastError from "../../errors/toastError";
import { leaveGroup } from "../../services/groupService";

const useStyles = makeStyles((theme) => ({
  warningContainer: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1),
    marginTop: theme.spacing(2),
    padding: theme.spacing(1.5),
    backgroundColor: theme.palette.warning.light,
    borderRadius: theme.shape.borderRadius,
  },
  warningIcon: {
    color: theme.palette.warning.dark,
  },
  btnWrapper: {
    position: "relative",
  },
  buttonProgress: {
    color: green[500],
    position: "absolute",
    top: "50%",
    left: "50%",
    marginTop: -12,
    marginLeft: -12,
  },
}));

const LeaveGroupModal = ({ open, onClose, group, onSuccess }) => {
  const classes = useStyles();
  const [loading, setLoading] = useState(false);

  const handleLeave = async () => {
    setLoading(true);
    try {
      await leaveGroup(group.id, group.whatsappId);
      toast.success(i18n.t("groupManagement.toasts.leftGroup"));
      onClose();
      if (onSuccess) {
        onSuccess();
      }
    } catch (err) {
      toastError(err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>{i18n.t("groupManagement.leaveModal.title")}</DialogTitle>
      <DialogContent>
        <DialogContentText>
          {i18n.t("groupManagement.leaveModal.message")}
        </DialogContentText>
        <div className={classes.warningContainer}>
          <WarningIcon className={classes.warningIcon} />
          <Typography variant="body2">
            {i18n.t("groupManagement.leaveModal.warning")}
          </Typography>
        </div>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="primary" disabled={loading}>
          {i18n.t("groupManagement.leaveModal.buttons.cancel")}
        </Button>
        <div className={classes.btnWrapper}>
          <Button
            onClick={handleLeave}
            color="secondary"
            variant="contained"
            disabled={loading}
          >
            {i18n.t("groupManagement.leaveModal.buttons.leave")}
          </Button>
          {loading && (
            <CircularProgress size={24} className={classes.buttonProgress} />
          )}
        </div>
      </DialogActions>
    </Dialog>
  );
};

export default LeaveGroupModal;
